module.exports = __webpack_public_path__ + "static/img/rabbit@2x.12f16d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/rabbit@2x.png
// module id = ZybQ
// module chunks = 2